import styled from "styled-components";
import ListWithPagination from "../ListsWithPagination";
import { TableWithPagination } from "../TableWithPagination";

interface Props {
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  totalNotifications: number;
  currentPage: number;
  limit: number;
  data: {
    id: string;
    title: string;
    body: string;
    date: string;
    notificationType: string;
  }[];
  isTableDataLoading: boolean;
}

const PushNotificationTable = ({
  setCurrentPage,
  totalNotifications,
  currentPage,
  limit,
  data,
  isTableDataLoading,
}: Props) => {
  const columns = [
    {
      path: "title",
      label: "Title",
    },
    {
      path: "notificationType",
      label: "Category",
    },
    {
      path: "body",
      label: "Message",
      content: (data: any) => (
        <div style={{ width: "100%" }}>
          <div style={{ whiteSpace: "initial" }}>{data.body}</div>
        </div>
      ),
    },
    {
      path: "date",
      label: "Date & Time",
    },
  ];
  
  return (
    <>
      <TableWrapper>
        <TableWithPagination
          onPageChange={setCurrentPage}
          totalData={totalNotifications}
          currentPage={currentPage}
          rowsPerPage={limit}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          onPageChange={setCurrentPage}
          totalData={totalNotifications}
          currentPage={currentPage}
          rowsPerPage={limit}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={"Push notification details"}
        />
      </ListWrapper>
    </>
  );
};

const TableWrapper = styled.div`
  display: flex;
  padding-top: 4.5rem;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    padding-top: 0rem;
    display: none;
  }
`;

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export default PushNotificationTable;
